var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.05469,
    y: 0.757812,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#82ABDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0547 13.2579H23.413L21.888 11.5912H16.888V13.2579H21.1547L22.6797 14.9245H26.0547V24.9245H12.7214V17.4245H11.0547V24.9245C11.0547 25.8412 11.8047 26.5912 12.7214 26.5912H26.0547C26.9714 26.5912 27.7214 25.8412 27.7214 24.9245V14.9245C27.7214 14.0079 26.9714 13.2579 26.0547 13.2579ZM15.2214 19.9245C15.2214 22.2245 17.088 24.0912 19.388 24.0912C21.688 24.0912 23.5547 22.2245 23.5547 19.9245C23.5547 17.6245 21.688 15.7579 19.388 15.7579C17.088 15.7579 15.2214 17.6245 15.2214 19.9245ZM19.388 17.4245C20.763 17.4245 21.888 18.5495 21.888 19.9245C21.888 21.2995 20.763 22.4245 19.388 22.4245C18.013 22.4245 16.888 21.2995 16.888 19.9245C16.888 18.5495 18.013 17.4245 19.388 17.4245ZM12.7214 13.2579H15.2214V11.5912H12.7214V9.09119H11.0547V11.5912H8.55469V13.2579H11.0547V15.7579H12.7214V13.2579Z",
    fill: "#2D73C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportImage);
export default __webpack_public_path__ + "static/media/import-image.cfb6af8e0cb8a7332a1ae7a80eca1e82.svg";
export { ForwardRef as ReactComponent };